import React, { Component } from "react";
import "./Course_list.scss";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Card from "../../common/card/card";
import { Link } from "react-router-dom";

const options = {
  rewind: true,
  autoplay: true,
  responsive: {
    0: {
      items: 1,
    },
    700: {
      items: 2,
    },
    1000: {
      items: 4,
    },
  },
};
class Course_list extends Component {
  render() {
    return (
      <div>
        {/* Basic start */}
        <div className="courseList">
          <div className="container-fluid">
            <div className="row">
              <div className="courseList_heading">
                <h2>Basic</h2>
              </div>
            </div>
            <OwlCarousel className="owl-theme" loop margin={30} {...options}>
              {/* C */}
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/C.png")}
                  heading="C"
                  para="Step By Step Tutorials To Learn Basics Of C Programming
                      Language Course"
                />
                                <Link id="courseButton" to="/courseDetails?content=C">
                  Courses details
                </Link>
              </div>
              {/* C */}

              {/* C++ */}
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/C++.png")}
                  heading="C++"
                  para=" C++ Training | CPP Classes | CPP Training Institute Pune |
                      C Plus Plus Classes | CPP Certification"
                />
                <Link id="courseButton" to="/courseDetails?content=CPP">
                  Courses details
                </Link>
              </div>
              {/* C++ */}

              {/* java */}

              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/Java.png")}
                  heading="Core Java"
                  para="Core Java Pune | Java Institutes In Pune | Java Courses In
                      Pune"
                />
                <Link id="courseButton" to="/courseDetails?content=CoreJava">
                  Courses details
                </Link>
              </div>
              {/* java */}
              {/* Python */}

              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/Python.png")}
                  heading="Python"
                  para="Core Python Pune | Python Institutes In Pune | Python Courses In
                      Pune"
                />
                <Link id="courseButton" to="/courseDetails?content=Python">
                  Courses details
                </Link>
              </div>
              {/* Python */}
              {/* html  */}
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/HTML.png")}
                  heading="HTML5 CCS3"
                  para="HTML5, CSS3, Jquery & Bootstrap Training Institute, Mobile
                      Responsive/Adaptive Classes, Certification & Coaching In
                      Pune, India"
                />
              </div>
              {/* html  */}

              {/* DS */}
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/Data structure.png")}
                  heading="DS"
                  para="Step By Step Tutorials To Learn Basics Of C Programming
                      Language Course"
                />
              </div>
              {/* DS */}
            </OwlCarousel>
          </div>
        </div>
        {/* Basic end */}

        {/* advance start */}
        <div className="courseList">
          <div className="container-fluid">
            <div className="row">
              <div className="courseList_heading">
                <h2>Advance</h2>
              </div>
            </div>
            <OwlCarousel className="owl-theme" loop margin={30} {...options}>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/node js.png")}
                  heading="Node js"
                  para="Node.js is an open-source, cross-platform, JavaScript
                      runtime environment that executes JavaScript code outside
                      of a browser."
                />
                <Link id="courseButton" to="/courseDetails?content=Angular">
                  Courses details
                </Link>
              </div>

              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/dot net.png")}
                  heading=".Net"
                  para="Learn to Build some of the best and finest enterprise based applications in .Net technology with us."
                />
                <Link id="courseButton" to="/courseDetails?content=Angular">
                  Courses details
                </Link>
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/angular.png")}
                  heading="Angular 2+"
                  para="Angular is a dynamic and robust JavaScript-based development framework used to create Single Page Applications."
                />
                <Link id="courseButton" to="/courseDetails?content=Angular">
                  Courses details
                </Link>
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/React js.png")}
                  heading="React js"
                  para="React is a view library to develop single page applications in Javascript. It is the most popular library backed by Facebook."
                />
                <Link id="courseButton" to="/courseDetails?content=Angular">
                  Courses details
                </Link>
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/Java.png")}
                  heading="Advance java"
                  para="In java advance one will cover topics such as Springs, Struts, JSP-Servlet, EJB and Hibernate."
                />
                <Link id="courseButton" to="/courseDetails?content=AdvanceJava">
                  Courses details
                </Link>
              </div>
            </OwlCarousel>
          </div>
        </div>
        {/* advance end */}
        {/* Database start */}
        <div className="courseList">
          <div className="container-fluid">
            <div className="row">
              <div className="courseList_heading">
                <h2>Oracle Courses </h2>
              </div>
            </div>
            <OwlCarousel className="owl-theme" loop margin={30} {...options}>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/oracle.png")}
                  heading="Oracle SQL"
                  para="SQL – 11g & 12c SQL course offers students a lecture/lab intensive environment on Oracle’s Data Server Technology."
                />
                <Link id="courseButton" to="/courseDetails?content=Oracle_SQL">
                  Courses details
                </Link>
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/Oracle PLSQL.png")}
                  heading="Oracle PLSQL"
                  para="This course introduces students to PL/SQL and helps them understand the benefits of this powerful programming language."
                />
                <Link id="courseButton" to="/courseDetails?content=PLSQL">
                  Courses details
                </Link>
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/oracle.png")}
                  heading="Oracle-DBA-L1"
                  para="Best Oracle DBA Training Institute in Pune with Placement. Industry approved Oracle DBA Training in Pune."
                />
                <Link
                  id="courseButton"
                  to="/courseDetails?content=OracleDBA_L1"
                >
                  Courses details
                </Link>
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/oracle.png")}
                  heading="Oracle DBA – L2"
                  para="Oracle DBA – L2 11G-12C is a backbone of the company and playing very important role in one’s carrier.These are the highest paid professionals in IT industry. "
                />
                <Link
                  id="courseButton"
                  to="/courseDetails?content=OracleDBA_L2"
                >
                  Courses details
                </Link>
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/data warehouse.png")}
                  heading="Data Warehouse"
                  para="In this course, students study the issues involved in planning, designing, building, populating, and maintaining a successful data warehouse."
                />
                <Link
                  id="courseButton"
                  to="/courseDetails?content=Data_Warehouse"
                >
                  Courses details
                </Link>
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/oracle goldengate.png")}
                  heading="Oracle golden gate"
                  para="Oracle RAC infrastructure is also a key component for implementing the Oracle enterprise grid computing architec"
                />
                <Link id="courseButton" to="/courseDetails?content=goldengate">
                  Courses details
                </Link>
              </div>
            </OwlCarousel>
          </div>
        </div>
        {/* Database end */}
        {/* Red hat start */}
        <div className="courseList">
          <div className="container-fluid">
            <div className="row">
              <div className="courseList_heading">
                <h2>Red Hat courses</h2>
              </div>
            </div>
            <OwlCarousel className="owl-theme" loop margin={30} {...options}>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/rhcsa-img-500x262.png")}
                  heading="RHCSA"
                  para="Red Hat Certified System Administrator (RHCSA) is considered to be the “basic” Red Hat certification."
                />
                <Link id="courseButton" to="/courseDetails?content=RHCSA">
                  Courses details
                </Link>
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/RHCE-img-500x262.png")}
                  heading="RHCE"
                  para="Red Hat Certified Engineer (RHCE) known as “crown jewel of Linux certifications” proves the eligibility of candidates on live systems."
                />
                <Link id="courseButton" to="/courseDetails?content=RHCE">
                  Courses details
                </Link>
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/devops.png")}
                  heading="DevOps"
                  para="This course will provide you with the in-depth knowledge of various DevOps tools"
                />
                <Link id="courseButton" to="/courseDetails?content=DevOps">
                  Courses details
                </Link>
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/ansible.png")}
                  heading="Ansible"
                  para="Learn how to install and configure Ansible, create and run playbooks to configure systems, and learn to manage inventories."
                />
                <Link id="courseButton" to="/courseDetails?content=Ansible">
                  Courses details
                </Link>
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/opnestack.png")}
                  heading="OpenStack"
                  para="This course is designed for system administrators who are intending to implement a cloud computing environment using Red Hat Open Stack® Platform"
                />
                <Link id="courseButton" to="/courseDetails?content=OpenStack">
                  Courses details
                </Link>
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/Server Hardening.png")}
                  heading="Server Hardening"
                  para="Red Hat Certified Server Hardening RH 413 is one of the reputed certification in security certifications."
                />
                <Link
                  id="courseButton"
                  to="/courseDetails?content=ServerHardening"
                >
                  Courses details
                </Link>
              </div>

              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/Virtualization.png")}
                  heading="Virtualization"
                  para="Red Hat Certified Virtualization Administrator (RHCVA) RH 318 certification is a performance-based certification like all other Red Hat Certifications."
                />
                <Link
                  id="courseButton"
                  to="/courseDetails?content=Virtualization"
                >
                  Courses details
                </Link>
              </div>
            </OwlCarousel>
          </div>
        </div>

        {/* Red hat end */}

        {/* Preplacement start */}
        <div className="courseList">
          <div className="container-fluid">
            <div className="row">
              <div className="courseList_heading">
                <h2>Preplacement courses</h2>
              </div>
            </div>
            <OwlCarousel className="owl-theme" loop margin={30} {...options}>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/soft skills.png")}
                  heading="Soft Skills"
                  para="Leadership Skills. Companies want employees who can supervise and direct other workers. "
                />
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/management.png")}
                  heading="Management Skills"
                  para="Management skills training is often promoted as a way for talented young managers to push their potential to be ready to take on greater responsibilities and exciting new challenges."
                />
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/aptitude.png")}
                  heading="Aptitude"
                  para="t also indicates the ability to retain, organize and apply information. This test is specially designed to check Basic Aptitude skills of a candidate."
                />
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/Advance programming.png")}
                  heading="Logical Reasoning"
                  para="Logical reasoning (verbal reasoning) refers to the ability of a candidate to understand and logically work through concepts and problems expressed in words."
                />
              </div>
              <div className="item">
                <Card
                  imgurl={require("../../../images/courses/interview.png")}
                  heading="Mock Interview"
                  para="The conversational exercise usually resembles a real interview as closely as possible, for the purpose of providing experience for a candidate."
                />
              </div>
            </OwlCarousel>
          </div>
        </div>
        {/* Preplacement end */}
      </div>
    );
  }
}

export default Course_list;
